/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import pinia from '../stores'
import router from '../router'
import { bus_setup } from '../utils/event_bus'
import VueQrcode from '@chenfengyuan/vue-qrcode'

export function registerPlugins(app) {

  // Plugins
  app
    .use(vuetify)
    .use(router)
    .use(pinia)
    .use(bus_setup)


  // Components
  app.component(VueQrcode.name, VueQrcode)
}
